var linkToTabs = (function () {

    function init() {
        
        var jumplink_exists = document.getElementsByClassName('tab-jump');

        if (jumplink_exists.length > 0) {
            bindUI(jumplink_exists);
        }

    }

    function bindUI(jumplinks) {

        for (var i = 0; i < jumplinks.length; i++) {
            jumplinks[i].addEventListener('click', bindEvents, false);
        }

    }


    /*
    * Bind the events
    * */
    function bindEvents() {

        var jumptab = this.getAttribute('data-tab-name');

        closePanels();
        openPanel(jumptab)

       /* 
        tabjump.each(function () {
            $(this).on('click', function () {
                
                var tabhash = $(this).attr("href");
                
                $('.collapse').removeClass('in');
                $(tabhash).find('a.collapsed').attr("aria-expanded","true").removeClass('collapsed');
                $(tabhash).next('h4 a.collapsed').attr("aria-expanded","true");
                $(tabhash).nextAll('div.panel-collapse').addClass('in').removeAttr("style").attr("aria-expanded","true");
                
            });
        });*/
    }

    function closePanels() {
        
        var panelsclosed = document.getElementsByClassName("in");
        
            for (var i = 0; i < panelsclosed.length; i++) {
                panelsclosed[i].classList.remove("in");
            }

        var arrowsclosed = document.getElementsByClassName("collapsed");

            for (var i = 0; i < arrowsclosed.length; i++) {
                arrowsclosed[i].setAttribute("aria-expanded", "false");
            }

        var toparrow = document.querySelectorAll('[role="button"]');

            toparrow[0].setAttribute("aria-expanded", "false");

    }

    function openPanel( whichpanel) {
        
        //open arrow
        const panel = document.querySelector(`#${whichpanel}`)
        let collapsibleSection = panel.nextElementSibling

        if(panel.classList.contains('wp-block-cite-wordpress-theme-accordion-item')) {
            collapsibleSection = panel.querySelector('.collapse')
        }

        panel.querySelector('[data-toggle="collapse"]').setAttribute("aria-expanded", "true");

        collapsibleSection.classList.add("in");
        collapsibleSection.removeAttribute("style");

        scrolltoPanel(whichpanel);

    }

    function scrolltoPanel( scrollme) {

        document.getElementById(scrollme).scrollIntoView({
            behavior: 'smooth' 
          });

    }

    init();

    // Return the object itself.
    return self;

}());
